import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/client';
import { useLanguage } from '../context/LanguageContext';
import './Auth.css';

function ForgotPassword() {
  const { t, language } = useLanguage();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const baseUrl = window.location.origin;
      await apiClient.post('/auth/forgot-password', { email, baseUrl, lang: language });
      setMessage(t('forgotPasswordSuccess'));
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.error || t('tryAgainLater'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page container">
      <div className="auth-card">
        <h1>{t('forgotPassword')}</h1>
        <p className="auth-subtext">{t('forgotPasswordSubtitle')}</p>

        {message && <div className="success">{message}</div>}
        {error && <div className="error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder={t('email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input"
          />
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? t('sending') : t('sendResetLink')}
          </button>
        </form>

        <div className="auth-divider">
          <span className="divider-line"></span>
          <span className="divider-text">{t('or')}</span>
          <span className="divider-line"></span>
        </div>

        <Link to="/login" className="btn btn-secondary">{t('back')}</Link>
      </div>
    </div>
  );
}

export default ForgotPassword;
